<template>
  <div class="main-container">
    <!-- 固定头部信息 -->
    <div class="header-section">
      <div class="back">
        <button class="back-button" @click="router.back()">
          <i class="iconfont icon-fanhuiicon mr5"></i> 返回
        </button>
      </div>
    </div>
    <!-- 主要内容区域 -->
    <div class="content-wrapper">

      <div class="qualification-categories">

        <div class="category-section">
          <h2 class="category-title">智能网联汽车道路测试与示范运营</h2>
          <div class="category-types">
            <div
                v-for="category in intelligent_connected_vehicle"
                :key="category.id"
                class="qualification-card"
                @click="selectQualification(category)"
            >
              <div class="card-header">
                <h3 class="card-title">{{ category.categoryName }}</h3>
              </div>

              <div class="card-content">
                <p class="card-description">{{ category.description }}</p>
              </div>

              <div class="card-footer">
                <span class="select-btn">点击申请</span>
              </div>
            </div>
          </div>
        </div>

        <div class="category-section">
          <h2 class="category-title">低速无人驾驶车辆道路测试与示范运营</h2>
          <div class="category-types">
            <div
                v-for="category in autonomous_vehicle"
                :key="category.id"
                class="qualification-card"
                @click="selectQualification(category)"
            >
              <div class="card-header">
                <h3 class="card-title">{{ category.categoryName }}</h3>
              </div>

              <div class="card-content">
                <p class="card-description">{{ category.description }}</p>
              </div>

              <div class="card-footer">
                <span class="select-btn">点击申请</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup name="QualificationApply">
import { onMounted, ref } from "vue";
import { useRouter } from 'vue-router';
import { message, Modal } from 'ant-design-vue';
import { categoryList } from '@/api/settings/category'
import { authenticationStatus } from '@/api/enterprise/index'

const router = useRouter();

let intelligent_connected_vehicle = ref();

let autonomous_vehicle = ref();

// 选择资质类型
const selectQualification = (category) => {
  // 检查认证状态
  if (!isAuthenticated.value) {
    // 未认证，显示提示模态框
    Modal.confirm({
      title: '企业认证提示',
      content: '您尚未完成企业认证，请先完成企业认证后再进行资质申请。',
      okText: '去认证',
      cancelText: '取消',
      onOk() {
        // 用户点击去认证，跳转到个人中心
        router.push('/userManagement/center');
      },
      onCancel() {
        console.log('用户取消认证');
      },
    });
    return;
  }
  
  // 认证通过，执行正常的申请流程
  if (category.categoryType === 'intelligent_connected_vehicle') {
    router.push(`/application/intelligent?type=${category.categoryType}&code=${category.categoryCode}`);
  }else if (category.categoryType === 'autonomous_vehicle'){
    router.push(`/application/autonomous?type=${category.categoryType}&code=${category.categoryCode}`);
  }

};

const getCategoryList = async () => {

  categoryList().then((res) => {
    intelligent_connected_vehicle.value = res.data.intelligent_connected_vehicle;
    autonomous_vehicle.value = res.data.autonomous_vehicle;
  });
}

// 检查企业认证状态
const checkAuthenticationStatus = async () => {
  try {
    const response = await authenticationStatus();
    // 假设接口返回的认证状态字段为authenticated，true表示已认证，false表示未认证
    // 具体字段需要根据实际接口返回调整
    // 这里检查response.data是否存在，因为实际接口可能直接返回认证状态
    return !!response.data;
  } catch (error) {
    console.error('检查企业认证状态失败:', error);
    // 发生错误时，默认为未认证
    return false;
  }
};

const isAuthenticated = ref(true); // 默认认证状态为true

onMounted(async () => {
  // 同时执行两个操作：检查认证状态和获取分类列表
  await getCategoryList();
  isAuthenticated.value = await checkAuthenticationStatus();
});
</script>

<style lang="less" scoped>
.main-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  overflow: hidden;
}

.header-section {
  flex-shrink: 0;
  padding: 20px 20px 0 20px;
  background-color: #ffffff;
  border-bottom: 1px solid #f0f0f0;
  z-index: 10;
}

.back {
  position: fixed;
  top: 93px;
  right: 50px;
  z-index: 20;
}

.back-button {
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 16px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.back-button:hover {
  background-color: #40a9ff;
}

.back-button:active {
  background-color: #096dd9;
}

.content-wrapper {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

.base-info {
  padding: 0 20px;
  margin: 20px 0;
}

.info-title {
  font-size: 16px;
  font-weight: 600;
  color: #1d2129;
  margin-bottom: 16px;
}

.info-content {
  background: #fff;
  border-radius: 4px;
  padding: 20px;
  border: 1px solid #f0f0f0;
}

.info-row {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}

.info-item {
  flex: 1;
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.info-label {
  font-size: 16px;
  color: #636d7b;
  margin-right: 8px;
  min-width: 80px;
}

.info-value {
  font-size: 16px;
  color: #1d2129;
}

.page-header {
  text-align: center;
  margin-bottom: 40px;

  h1 {
    font-size: 28px;
    font-weight: 600;
    color: #1d2129;
    margin-bottom: 8px;
  }

  .subtitle {
    font-size: 16px;
    color: #636d7b;
  }
}

.qualification-categories {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.category-section {
  background: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 12px;
}

.category-title {
  font-size: 16px;
  font-weight: 500;
  color: #1d2129;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e8e8e8;
}

.category-types {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.qualification-card {
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  min-height: 150px;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
    border-color: #40a9ff;
  }

  &:active {
    transform: translateY(0);
  }
}

.card-header {
  margin-bottom: 12px;

  .card-title {
    font-size: 16px;
    font-weight: 500;
    color: #1d2129;
    margin: 0;
  }
}

.card-content {
  flex: 1;
  margin-bottom: 12px;

  .card-description {
    font-size: 14px;
    color: #636d7b;
    line-height: 1.6;
    margin-bottom: 0;
  }

  .requirements-section {
    .requirements-title {
      font-size: 14px;
      font-weight: 500;
      color: #1d2129;
      margin-bottom: 8px;
    }

    .requirements-list {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        font-size: 13px;
        color: #636d7b;
        line-height: 1.8;
        margin-bottom: 4px;

        .requirement-dot {
          color: #40a9ff;
          margin-right: 6px;
        }
      }
    }
  }
}

.card-footer {
  margin-top: auto;
  padding-top: 12px;
  text-align: right;
  border-top: 1px solid #f0f0f0;

  .select-btn {
    font-size: 14px;
    color: #40a9ff;
    font-weight: 500;
  }
}

// 自定义滚动条样式
.content-wrapper::-webkit-scrollbar {
  width: 6px;
}

.content-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.content-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.content-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

// 响应式设计
@media (max-width: 768px) {
  .content-wrapper {
    padding: 16px;
  }

  .page-header h1 {
    font-size: 24px;
  }

  .category-types {
    grid-template-columns: 1fr;
  }

  .back {
    position: relative;
    top: 0;
    right: 0;
    margin-bottom: 20px;
  }
}
</style>